import { SocieteCaracteristiqueChoixSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const SocieteCaracteristiqueChoixModel: SelectorModel = {
  name: 'societeCaracteristiqueChoices',
  getSelector: SocieteCaracteristiqueChoixSelectors.selectAllSocieteCaracteristiqueChoicesDictionary,
  isReady: SocieteCaracteristiqueChoixSelectors.selectIsReadySocieteCaracteristiqueChoix
};
